module.exports = __webpack_public_path__ + "static/media/bell.20cc53dc.png";